<template>
  <v-card class="mx-auto mt-10" max-width="600">
    <v-card-title>Forgot/Change Password</v-card-title>
    <v-card-text class="red--text" v-if="formError">{{
      formError
    }}</v-card-text>
    <v-card-text class="green--text" v-if="formSuccess">{{
      formSuccess
    }}</v-card-text>
    <v-form v-if="!codeSent" @submit.prevent="submit">
      <v-card-text>
        <v-text-field
          v-model="email"
          label="Email"
          :error-messages="emailErrors"
          @input="$v.email.$touch()"
          @blur="$v.email.$touch()"
          required
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" @click.prevent="submit" :disabled="loading">
          Send Link!
          <v-progress-circular
            indeterminate
            v-if="loading"
          ></v-progress-circular
        ></v-btn>
      </v-card-actions>
    </v-form>
    <v-form v-else @submit.prevent="resetPassword">
      <v-card-text>
        <v-text-field
          v-model="email"
          label="Email"
          :error-messages="emailErrors"
          @input="$v.email.$touch()"
          @blur="$v.email.$touch()"
          required
        ></v-text-field>
        <v-text-field v-model="code" label="Code" required></v-text-field>
        <v-text-field
          v-model="password"
          label="Password"
          type="password"
          required
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          @click.prevent="resetPassword"
          :disabled="loading"
        >
          Reset Password
          <v-progress-circular
            indeterminate
            v-if="loading"
          ></v-progress-circular>
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { required, email } from "vuelidate/lib/validators";
import { mapActions } from "vuex";

import axios from "axios";

export default {
  name: "VuelidateLogin",
  validations: {
    email: { required, email }
  },
  methods: {
    ...mapActions("cognito", ["forgotPassword", "changePassword"]),
    async submit() {
      this.formError = null;
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.loading = true;
      const { data } = await axios.get("/api/user/cognito", {
        params: { email: this.email }
      });

      const { username } = data;

      if (username) {
        await this.forgotPassword({
          username
        });

        this.codeSent = true;
      } else {
        this.formError = "Please provide an email of a registered user";
      }
      this.loading = false;
    },
    async resetPassword() {
      this.$v.$touch();
      this.formError = null;

      if (this.$v.$invalid) return;
      this.loading = true;

      const { data } = await axios.get("/api/user/cognito", {
        params: { email: this.email }
      });

      const { username } = data;

      if (username) {
        try {
          await this.changePassword({
            username,
            code: this.code,
            newPassword: this.password
          });
          this.formSuccess =
            "Successfully reset password! U will be redirected to the Login page";

          setTimeout(() => this.$router.push("/login"), 3000);
        } catch (err) {
          console.error(err);
          if (err.code === "CodeMismatchException") {
            this.formError = "Invalid code";
          }
          if (err.code === "InvalidParameterException") {
            this.formError = "Invalid Code";
          }
          if (err.code === "InvalidPasswordException") {
            this.formError =
              "Invalid password, the password has to be 8 characters long...";
          }
          if (err.code === "ExpiredCodeException") {
            this.formError = "Code expired, please try again.";
          }
          if (err.code === "LimitExceededException") {
            this.formError = "U tried too many times, please try again.";
          }

          this.loading = false;
        }
      }
    }
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    }
  },
  data: () => ({
    email: null,
    codeSent: false,
    code: null,
    password: null,
    loading: false,
    formError: null,
    formSuccess: null
  })
};
</script>
